// extracted by mini-css-extract-plugin
export default {"add_position_modal":"AddPositionModal_add_position_modal__dLZeG","add_position_form":"AddPositionModal_add_position_form__uyZkq"};